export const r1 = v => Math.round((parseFloat(v) || 0) * 10) / 10;

// Convierte "yyyy-mm-dd" → "dd-mm-yyyy" para mostrar al usuario
export const fmtFecha = (s) => {
  if (!s) return s;
  const p = String(s).split('T')[0].split('-');
  if (p.length !== 3) return s;
  return `${p[2]}-${p[1]}-${p[0]}`;
};

export function detectarTipoComida(nombre = "") {
  const h = new Date().getHours();
  const m = new Date().getMinutes();
  const mins = h * 60 + m;
  if (mins >= 6 * 60 && mins < 7 * 60) return "Desayuno";
  if (mins >= 7 * 60 && mins < 9 * 60 + 45) return "Media mañana";
  if (mins >= 9 * 60 + 45 && mins < 13 * 60) return "Almuerzo";
  if (mins >= 13 * 60 && mins < 17 * 60) return "Pre-entrenamiento";
  return "Cena"; // 17:00-06:00 — madrugada también
}

export const compressImage = (file) => new Promise((resolve) => {
  const canvas = document.createElement("canvas");
  const img = new Image();
  img.onload = () => {
    const max = 1600;
    let w = img.width, h = img.height;
    if (w > max || h > max) { if (w > h) { h = h * max / w; w = max; } else { w = w * max / h; h = max; } }
    canvas.width = w; canvas.height = h;
    canvas.getContext("2d").drawImage(img, 0, 0, w, h);
    resolve(canvas.toDataURL("image/jpeg", 0.9));
  };
  img.src = URL.createObjectURL(file);
});
